// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   Korean Font Support - Noto Sans KR
   ============================================================================ */

   * {
     margin: 0;
     padding: 0;
     box-sizing: border-box;
     font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
   }
   
   body {
     font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
     background: #f5f5f5;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
   }
   
   .app {
     display: flex;
     min-height: 100vh;
   }
   
   /* Sidebar */
   .sidebar {
     width: 250px;
     background: #2c3e50;
     color: white;
     display: flex;
     flex-direction: column;
     position: fixed;
     height: 100vh;
     overflow-y: auto;
   }
   
   .sidebar-header {
     padding: 20px;
     background: #34495e;
     border-bottom: 1px solid #465669;
   }
   
   .sidebar-header h2 {
     font-size: 20px;
     font-weight: 600;
   }
   
   .nav-links {
     list-style: none;
     padding: 20px 0;
     flex: 1 1;
   }
   
   .nav-links li {
     margin-bottom: 5px;
   }
   
   .nav-links a {
     display: block;
     padding: 12px 20px;
     color: #ecf0f1;
     text-decoration: none;
     transition: background 0.2s;
   }
   
   .nav-links a:hover {
     background: #34495e;
   }
   
   .sidebar-footer {
     padding: 20px;
     border-top: 1px solid #465669;
   }
   
   .logout-btn {
     width: 100%;
     padding: 10px;
     background: #e74c3c;
     color: white;
     border: none;
     border-radius: 4px;
     cursor: pointer;
     font-size: 14px;
   }
   
   .logout-btn:hover {
     background: #c0392b;
   }
   
   /* Main Content */
   .main-content {
     flex: 1 1;
     margin-left: 250px;
     padding: 30px;
     overflow-y: auto;
   }
   
   /* Page Header */
   .page-header {
     margin-bottom: 30px;
   }
   
   .page-header h1 {
     font-size: 28px;
     color: #2c3e50;
     margin-bottom: 10px;
   }
   
   .page-header p {
     color: #7f8c8d;
   }
   
   /* Cards */
   .card {
     background: white;
     border-radius: 8px;
     padding: 20px;
     box-shadow: 0 2px 4px rgba(0,0,0,0.1);
     margin-bottom: 20px;
   }
   
   .card-header {
     display: flex;
     justify-content: space-between;
     align-items: center;
     margin-bottom: 20px;
     padding-bottom: 15px;
     border-bottom: 1px solid #ecf0f1;
   }
   
   .card-header h2 {
     font-size: 20px;
     color: #2c3e50;
   }
   
   /* Stats Grid */
   .stats-grid {
     display: grid;
     grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
     gap: 20px;
     margin-bottom: 30px;
   }
   
   .stat-card {
     background: white;
     padding: 20px;
     border-radius: 8px;
     box-shadow: 0 2px 4px rgba(0,0,0,0.1);
   }
   
   .stat-card h3 {
     color: #7f8c8d;
     font-size: 14px;
     font-weight: 500;
     margin-bottom: 10px;
   }
   
   .stat-card .value {
     font-size: 32px;
     font-weight: 700;
     color: #2c3e50;
   }
   
   /* Buttons */
   .btn {
     padding: 10px 20px;
     border: none;
     border-radius: 4px;
     cursor: pointer;
     font-size: 14px;
     transition: all 0.2s;
   }
   
   .btn-primary {
     background: #3498db;
     color: white;
   }
   
   .btn-primary:hover {
     background: #2980b9;
   }
   
   .btn-success {
     background: #27ae60;
     color: white;
   }
   
   .btn-success:hover {
     background: #229954;
   }
   
   .btn-danger {
     background: #e74c3c;
     color: white;
   }
   
   .btn-danger:hover {
     background: #c0392b;
   }
   
   .btn-secondary {
     background: #95a5a6;
     color: white;
   }
   
   .btn-secondary:hover {
     background: #7f8c8d;
   }
   
   /* Table */
   .table-container {
     overflow-x: auto;
   }
   
   table {
     width: 100%;
     border-collapse: collapse;
   }
   
   thead {
     background: #f8f9fa;
   }
   
   th {
     padding: 12px;
     text-align: left;
     font-weight: 600;
     color: #2c3e50;
     border-bottom: 2px solid #dee2e6;
     font-size: 14px;
   }
   
   td {
     padding: 12px;
     border-bottom: 1px solid #dee2e6;
     font-size: 14px;
   }
   
   tr:hover {
     background: #f8f9fa;
   }
   
   /* Forms */
   .form-group {
     margin-bottom: 20px;
   }
   
   .form-group label {
     display: block;
     margin-bottom: 5px;
     font-weight: 500;
     color: #2c3e50;
   }
   
   .form-control {
     width: 100%;
     padding: 10px;
     border: 1px solid #ddd;
     border-radius: 4px;
     font-size: 14px;
   }
   
   .form-control:focus {
     outline: none;
     border-color: #3498db;
   }
   
   textarea.form-control {
     min-height: 100px;
     resize: vertical;
   }
   
   select.form-control {
     cursor: pointer;
   }
   
   /* Filters */
   .filters {
     display: flex;
     gap: 15px;
     margin-bottom: 20px;
     flex-wrap: wrap;
   }
   
   .filter-item {
     flex: 1 1;
     min-width: 200px;
   }
   
   /* Pagination */
   .pagination {
     display: flex;
     justify-content: center;
     align-items: center;
     gap: 10px;
     margin-top: 20px;
   }
   
   .pagination button {
     padding: 8px 12px;
     border: 1px solid #ddd;
     background: white;
     cursor: pointer;
     border-radius: 4px;
   }
   
   .pagination button:hover:not(:disabled) {
     background: #f8f9fa;
   }
   
   .pagination button:disabled {
     opacity: 0.5;
     cursor: not-allowed;
   }
   
   .pagination span {
     color: #7f8c8d;
   }
   
   /* Badges */
   .badge {
     display: inline-block;
     padding: 4px 8px;
     border-radius: 12px;
     font-size: 12px;
     font-weight: 500;
   }
   
   .badge-success {
     background: #d4edda;
     color: #155724;
   }
   
   .badge-danger {
     background: #f8d7da;
     color: #721c24;
   }
   
   .badge-warning {
     background: #fff3cd;
     color: #856404;
   }
   
   .badge-info {
     background: #d1ecf1;
     color: #0c5460;
   }
   
   /* Login Page */
   .login-container {
     display: flex;
     justify-content: center;
     align-items: center;
     min-height: 100vh;
     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
   }
   
   .login-box {
     background: white;
     padding: 40px;
     border-radius: 8px;
     box-shadow: 0 10px 25px rgba(0,0,0,0.2);
     width: 100%;
     max-width: 400px;
   }
   
   .login-box h2 {
     text-align: center;
     margin-bottom: 30px;
     color: #2c3e50;
   }
   
   /* Loading */
   .loading {
     text-align: center;
     padding: 40px;
     color: #7f8c8d;
   }
   
   /* Error */
   .error {
     background: #f8d7da;
     color: #721c24;
     padding: 15px;
     border-radius: 4px;
     margin-bottom: 20px;
   }
   
   /* Success Message */
   .success {
     background: #d4edda;
     color: #155724;
     padding: 15px;
     border-radius: 4px;
     margin-bottom: 20px;
   }
   
   /* User info in sidebar */
   .user-info {
     display: flex;
     flex-direction: column;
     gap: 4px;
     margin-top: 10px;
   }
   
   .user-name {
     font-size: 14px;
     color: #ecf0f1;
     font-weight: 500;
   }
   
   .user-role {
     font-size: 12px;
     color: #95a5a6;
     text-transform: capitalize;
   }
   
   /* Navigation divider */
   .nav-divider {
     border-top: 1px solid #465669;
     margin: 10px 15px;
     padding: 0 !important;
   }
   
   /* Active nav item */
   .nav-links li.active a {
     background: #3498db;
     border-left: 3px solid #2980b9;
   }
   
   /* Login Tabs */
   .login-tabs {
     display: flex;
     margin-bottom: 25px;
     border-radius: 8px;
     overflow: hidden;
     border: 1px solid #ddd;
   }
   
   .login-tab {
     flex: 1 1;
     padding: 12px;
     border: none;
     background: #f8f9fa;
     cursor: pointer;
     font-size: 14px;
     font-weight: 500;
     color: #7f8c8d;
     transition: all 0.2s;
   }
   
   .login-tab:first-child {
     border-right: 1px solid #ddd;
   }
   
   .login-tab.active {
     background: #3498db;
     color: white;
   }
   
   .login-tab:hover:not(.active) {
     background: #ecf0f1;
   }
   
   /* Loading screen */
   .loading-screen {
     display: flex;
     justify-content: center;
     align-items: center;
     min-height: 100vh;
     background: #f5f5f5;
   }
   
   .loading-spinner {
     font-size: 18px;
     color: #7f8c8d;
   }
   
   /* Modal Overlay */
   .modal-overlay {
     position: fixed;
     top: 0;
     left: 0;
     right: 0;
     bottom: 0;
     background: rgba(0, 0, 0, 0.5);
     display: flex;
     justify-content: center;
     align-items: center;
     z-index: 1000;
   }
   
   .modal-content {
     background: white;
     padding: 30px;
     border-radius: 8px;
     max-width: 600px;
     width: 90%;
     max-height: 80vh;
     overflow-y: auto;
     box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
   }
   
   .modal-content h2 {
     margin-bottom: 20px;
     color: #2c3e50;
   }
   
   /* Badge colors */
   .badge-primary {
     background: #3498db;
     color: white;
   }
   
   .badge-secondary {
     background: #95a5a6;
     color: white;
   }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;iFAEiF;;GAG9E;KACE,SAAS;KACT,UAAU;KACV,sBAAsB;KACtB,8KAA8K;GAChL;;GAEA;KACE,8KAA8K;KAC9K,mBAAmB;KACnB,mCAAmC;KACnC,kCAAkC;GACpC;;GAEA;KACE,aAAa;KACb,iBAAiB;GACnB;;GAEA,YAAY;GACZ;KACE,YAAY;KACZ,mBAAmB;KACnB,YAAY;KACZ,aAAa;KACb,sBAAsB;KACtB,eAAe;KACf,aAAa;KACb,gBAAgB;GAClB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,gCAAgC;GAClC;;GAEA;KACE,eAAe;KACf,gBAAgB;GAClB;;GAEA;KACE,gBAAgB;KAChB,eAAe;KACf,SAAO;GACT;;GAEA;KACE,kBAAkB;GACpB;;GAEA;KACE,cAAc;KACd,kBAAkB;KAClB,cAAc;KACd,qBAAqB;KACrB,2BAA2B;GAC7B;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,6BAA6B;GAC/B;;GAEA;KACE,WAAW;KACX,aAAa;KACb,mBAAmB;KACnB,YAAY;KACZ,YAAY;KACZ,kBAAkB;KAClB,eAAe;KACf,eAAe;GACjB;;GAEA;KACE,mBAAmB;GACrB;;GAEA,iBAAiB;GACjB;KACE,SAAO;KACP,kBAAkB;KAClB,aAAa;KACb,gBAAgB;GAClB;;GAEA,gBAAgB;GAChB;KACE,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,cAAc;KACd,mBAAmB;GACrB;;GAEA;KACE,cAAc;GAChB;;GAEA,UAAU;GACV;KACE,iBAAiB;KACjB,kBAAkB;KAClB,aAAa;KACb,qCAAqC;KACrC,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,8BAA8B;KAC9B,mBAAmB;KACnB,mBAAmB;KACnB,oBAAoB;KACpB,gCAAgC;GAClC;;GAEA;KACE,eAAe;KACf,cAAc;GAChB;;GAEA,eAAe;GACf;KACE,aAAa;KACb,2DAA2D;KAC3D,SAAS;KACT,mBAAmB;GACrB;;GAEA;KACE,iBAAiB;KACjB,aAAa;KACb,kBAAkB;KAClB,qCAAqC;GACvC;;GAEA;KACE,cAAc;KACd,eAAe;KACf,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,cAAc;GAChB;;GAEA,YAAY;GACZ;KACE,kBAAkB;KAClB,YAAY;KACZ,kBAAkB;KAClB,eAAe;KACf,eAAe;KACf,oBAAoB;GACtB;;GAEA;KACE,mBAAmB;KACnB,YAAY;GACd;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;KACnB,YAAY;GACd;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;KACnB,YAAY;GACd;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;KACnB,YAAY;GACd;;GAEA;KACE,mBAAmB;GACrB;;GAEA,UAAU;GACV;KACE,gBAAgB;GAClB;;GAEA;KACE,WAAW;KACX,yBAAyB;GAC3B;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,gBAAgB;KAChB,gBAAgB;KAChB,cAAc;KACd,gCAAgC;KAChC,eAAe;GACjB;;GAEA;KACE,aAAa;KACb,gCAAgC;KAChC,eAAe;GACjB;;GAEA;KACE,mBAAmB;GACrB;;GAEA,UAAU;GACV;KACE,mBAAmB;GACrB;;GAEA;KACE,cAAc;KACd,kBAAkB;KAClB,gBAAgB;KAChB,cAAc;GAChB;;GAEA;KACE,WAAW;KACX,aAAa;KACb,sBAAsB;KACtB,kBAAkB;KAClB,eAAe;GACjB;;GAEA;KACE,aAAa;KACb,qBAAqB;GACvB;;GAEA;KACE,iBAAiB;KACjB,gBAAgB;GAClB;;GAEA;KACE,eAAe;GACjB;;GAEA,YAAY;GACZ;KACE,aAAa;KACb,SAAS;KACT,mBAAmB;KACnB,eAAe;GACjB;;GAEA;KACE,SAAO;KACP,gBAAgB;GAClB;;GAEA,eAAe;GACf;KACE,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,SAAS;KACT,gBAAgB;GAClB;;GAEA;KACE,iBAAiB;KACjB,sBAAsB;KACtB,iBAAiB;KACjB,eAAe;KACf,kBAAkB;GACpB;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,YAAY;KACZ,mBAAmB;GACrB;;GAEA;KACE,cAAc;GAChB;;GAEA,WAAW;GACX;KACE,qBAAqB;KACrB,gBAAgB;KAChB,mBAAmB;KACnB,eAAe;KACf,gBAAgB;GAClB;;GAEA;KACE,mBAAmB;KACnB,cAAc;GAChB;;GAEA;KACE,mBAAmB;KACnB,cAAc;GAChB;;GAEA;KACE,mBAAmB;KACnB,cAAc;GAChB;;GAEA;KACE,mBAAmB;KACnB,cAAc;GAChB;;GAEA,eAAe;GACf;KACE,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,iBAAiB;KACjB,6DAA6D;GAC/D;;GAEA;KACE,iBAAiB;KACjB,aAAa;KACb,kBAAkB;KAClB,uCAAuC;KACvC,WAAW;KACX,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,mBAAmB;KACnB,cAAc;GAChB;;GAEA,YAAY;GACZ;KACE,kBAAkB;KAClB,aAAa;KACb,cAAc;GAChB;;GAEA,UAAU;GACV;KACE,mBAAmB;KACnB,cAAc;KACd,aAAa;KACb,kBAAkB;KAClB,mBAAmB;GACrB;;GAEA,oBAAoB;GACpB;KACE,mBAAmB;KACnB,cAAc;KACd,aAAa;KACb,kBAAkB;KAClB,mBAAmB;GACrB;;GAEA,yBAAyB;GACzB;KACE,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,gBAAgB;GAClB;;GAEA;KACE,eAAe;KACf,cAAc;KACd,gBAAgB;GAClB;;GAEA;KACE,eAAe;KACf,cAAc;KACd,0BAA0B;GAC5B;;GAEA,uBAAuB;GACvB;KACE,6BAA6B;KAC7B,iBAAiB;KACjB,qBAAqB;GACvB;;GAEA,oBAAoB;GACpB;KACE,mBAAmB;KACnB,8BAA8B;GAChC;;GAEA,eAAe;GACf;KACE,aAAa;KACb,mBAAmB;KACnB,kBAAkB;KAClB,gBAAgB;KAChB,sBAAsB;GACxB;;GAEA;KACE,SAAO;KACP,aAAa;KACb,YAAY;KACZ,mBAAmB;KACnB,eAAe;KACf,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,oBAAoB;GACtB;;GAEA;KACE,4BAA4B;GAC9B;;GAEA;KACE,mBAAmB;KACnB,YAAY;GACd;;GAEA;KACE,mBAAmB;GACrB;;GAEA,mBAAmB;GACnB;KACE,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,iBAAiB;KACjB,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,cAAc;GAChB;;GAEA,kBAAkB;GAClB;KACE,eAAe;KACf,MAAM;KACN,OAAO;KACP,QAAQ;KACR,SAAS;KACT,8BAA8B;KAC9B,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,aAAa;GACf;;GAEA;KACE,iBAAiB;KACjB,aAAa;KACb,kBAAkB;KAClB,gBAAgB;KAChB,UAAU;KACV,gBAAgB;KAChB,gBAAgB;KAChB,0CAA0C;GAC5C;;GAEA;KACE,mBAAmB;KACnB,cAAc;GAChB;;GAEA,iBAAiB;GACjB;KACE,mBAAmB;KACnB,YAAY;GACd;;GAEA;KACE,mBAAmB;KACnB,YAAY;GACd","sourcesContent":["/* ============================================================================\n   Korean Font Support - Noto Sans KR\n   ============================================================================ */\n   @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;500;600;700&display=swap');\n\n   * {\n     margin: 0;\n     padding: 0;\n     box-sizing: border-box;\n     font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n   }\n   \n   body {\n     font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n     background: #f5f5f5;\n     -webkit-font-smoothing: antialiased;\n     -moz-osx-font-smoothing: grayscale;\n   }\n   \n   .app {\n     display: flex;\n     min-height: 100vh;\n   }\n   \n   /* Sidebar */\n   .sidebar {\n     width: 250px;\n     background: #2c3e50;\n     color: white;\n     display: flex;\n     flex-direction: column;\n     position: fixed;\n     height: 100vh;\n     overflow-y: auto;\n   }\n   \n   .sidebar-header {\n     padding: 20px;\n     background: #34495e;\n     border-bottom: 1px solid #465669;\n   }\n   \n   .sidebar-header h2 {\n     font-size: 20px;\n     font-weight: 600;\n   }\n   \n   .nav-links {\n     list-style: none;\n     padding: 20px 0;\n     flex: 1;\n   }\n   \n   .nav-links li {\n     margin-bottom: 5px;\n   }\n   \n   .nav-links a {\n     display: block;\n     padding: 12px 20px;\n     color: #ecf0f1;\n     text-decoration: none;\n     transition: background 0.2s;\n   }\n   \n   .nav-links a:hover {\n     background: #34495e;\n   }\n   \n   .sidebar-footer {\n     padding: 20px;\n     border-top: 1px solid #465669;\n   }\n   \n   .logout-btn {\n     width: 100%;\n     padding: 10px;\n     background: #e74c3c;\n     color: white;\n     border: none;\n     border-radius: 4px;\n     cursor: pointer;\n     font-size: 14px;\n   }\n   \n   .logout-btn:hover {\n     background: #c0392b;\n   }\n   \n   /* Main Content */\n   .main-content {\n     flex: 1;\n     margin-left: 250px;\n     padding: 30px;\n     overflow-y: auto;\n   }\n   \n   /* Page Header */\n   .page-header {\n     margin-bottom: 30px;\n   }\n   \n   .page-header h1 {\n     font-size: 28px;\n     color: #2c3e50;\n     margin-bottom: 10px;\n   }\n   \n   .page-header p {\n     color: #7f8c8d;\n   }\n   \n   /* Cards */\n   .card {\n     background: white;\n     border-radius: 8px;\n     padding: 20px;\n     box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n     margin-bottom: 20px;\n   }\n   \n   .card-header {\n     display: flex;\n     justify-content: space-between;\n     align-items: center;\n     margin-bottom: 20px;\n     padding-bottom: 15px;\n     border-bottom: 1px solid #ecf0f1;\n   }\n   \n   .card-header h2 {\n     font-size: 20px;\n     color: #2c3e50;\n   }\n   \n   /* Stats Grid */\n   .stats-grid {\n     display: grid;\n     grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n     gap: 20px;\n     margin-bottom: 30px;\n   }\n   \n   .stat-card {\n     background: white;\n     padding: 20px;\n     border-radius: 8px;\n     box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n   }\n   \n   .stat-card h3 {\n     color: #7f8c8d;\n     font-size: 14px;\n     font-weight: 500;\n     margin-bottom: 10px;\n   }\n   \n   .stat-card .value {\n     font-size: 32px;\n     font-weight: 700;\n     color: #2c3e50;\n   }\n   \n   /* Buttons */\n   .btn {\n     padding: 10px 20px;\n     border: none;\n     border-radius: 4px;\n     cursor: pointer;\n     font-size: 14px;\n     transition: all 0.2s;\n   }\n   \n   .btn-primary {\n     background: #3498db;\n     color: white;\n   }\n   \n   .btn-primary:hover {\n     background: #2980b9;\n   }\n   \n   .btn-success {\n     background: #27ae60;\n     color: white;\n   }\n   \n   .btn-success:hover {\n     background: #229954;\n   }\n   \n   .btn-danger {\n     background: #e74c3c;\n     color: white;\n   }\n   \n   .btn-danger:hover {\n     background: #c0392b;\n   }\n   \n   .btn-secondary {\n     background: #95a5a6;\n     color: white;\n   }\n   \n   .btn-secondary:hover {\n     background: #7f8c8d;\n   }\n   \n   /* Table */\n   .table-container {\n     overflow-x: auto;\n   }\n   \n   table {\n     width: 100%;\n     border-collapse: collapse;\n   }\n   \n   thead {\n     background: #f8f9fa;\n   }\n   \n   th {\n     padding: 12px;\n     text-align: left;\n     font-weight: 600;\n     color: #2c3e50;\n     border-bottom: 2px solid #dee2e6;\n     font-size: 14px;\n   }\n   \n   td {\n     padding: 12px;\n     border-bottom: 1px solid #dee2e6;\n     font-size: 14px;\n   }\n   \n   tr:hover {\n     background: #f8f9fa;\n   }\n   \n   /* Forms */\n   .form-group {\n     margin-bottom: 20px;\n   }\n   \n   .form-group label {\n     display: block;\n     margin-bottom: 5px;\n     font-weight: 500;\n     color: #2c3e50;\n   }\n   \n   .form-control {\n     width: 100%;\n     padding: 10px;\n     border: 1px solid #ddd;\n     border-radius: 4px;\n     font-size: 14px;\n   }\n   \n   .form-control:focus {\n     outline: none;\n     border-color: #3498db;\n   }\n   \n   textarea.form-control {\n     min-height: 100px;\n     resize: vertical;\n   }\n   \n   select.form-control {\n     cursor: pointer;\n   }\n   \n   /* Filters */\n   .filters {\n     display: flex;\n     gap: 15px;\n     margin-bottom: 20px;\n     flex-wrap: wrap;\n   }\n   \n   .filter-item {\n     flex: 1;\n     min-width: 200px;\n   }\n   \n   /* Pagination */\n   .pagination {\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     gap: 10px;\n     margin-top: 20px;\n   }\n   \n   .pagination button {\n     padding: 8px 12px;\n     border: 1px solid #ddd;\n     background: white;\n     cursor: pointer;\n     border-radius: 4px;\n   }\n   \n   .pagination button:hover:not(:disabled) {\n     background: #f8f9fa;\n   }\n   \n   .pagination button:disabled {\n     opacity: 0.5;\n     cursor: not-allowed;\n   }\n   \n   .pagination span {\n     color: #7f8c8d;\n   }\n   \n   /* Badges */\n   .badge {\n     display: inline-block;\n     padding: 4px 8px;\n     border-radius: 12px;\n     font-size: 12px;\n     font-weight: 500;\n   }\n   \n   .badge-success {\n     background: #d4edda;\n     color: #155724;\n   }\n   \n   .badge-danger {\n     background: #f8d7da;\n     color: #721c24;\n   }\n   \n   .badge-warning {\n     background: #fff3cd;\n     color: #856404;\n   }\n   \n   .badge-info {\n     background: #d1ecf1;\n     color: #0c5460;\n   }\n   \n   /* Login Page */\n   .login-container {\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     min-height: 100vh;\n     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n   }\n   \n   .login-box {\n     background: white;\n     padding: 40px;\n     border-radius: 8px;\n     box-shadow: 0 10px 25px rgba(0,0,0,0.2);\n     width: 100%;\n     max-width: 400px;\n   }\n   \n   .login-box h2 {\n     text-align: center;\n     margin-bottom: 30px;\n     color: #2c3e50;\n   }\n   \n   /* Loading */\n   .loading {\n     text-align: center;\n     padding: 40px;\n     color: #7f8c8d;\n   }\n   \n   /* Error */\n   .error {\n     background: #f8d7da;\n     color: #721c24;\n     padding: 15px;\n     border-radius: 4px;\n     margin-bottom: 20px;\n   }\n   \n   /* Success Message */\n   .success {\n     background: #d4edda;\n     color: #155724;\n     padding: 15px;\n     border-radius: 4px;\n     margin-bottom: 20px;\n   }\n   \n   /* User info in sidebar */\n   .user-info {\n     display: flex;\n     flex-direction: column;\n     gap: 4px;\n     margin-top: 10px;\n   }\n   \n   .user-name {\n     font-size: 14px;\n     color: #ecf0f1;\n     font-weight: 500;\n   }\n   \n   .user-role {\n     font-size: 12px;\n     color: #95a5a6;\n     text-transform: capitalize;\n   }\n   \n   /* Navigation divider */\n   .nav-divider {\n     border-top: 1px solid #465669;\n     margin: 10px 15px;\n     padding: 0 !important;\n   }\n   \n   /* Active nav item */\n   .nav-links li.active a {\n     background: #3498db;\n     border-left: 3px solid #2980b9;\n   }\n   \n   /* Login Tabs */\n   .login-tabs {\n     display: flex;\n     margin-bottom: 25px;\n     border-radius: 8px;\n     overflow: hidden;\n     border: 1px solid #ddd;\n   }\n   \n   .login-tab {\n     flex: 1;\n     padding: 12px;\n     border: none;\n     background: #f8f9fa;\n     cursor: pointer;\n     font-size: 14px;\n     font-weight: 500;\n     color: #7f8c8d;\n     transition: all 0.2s;\n   }\n   \n   .login-tab:first-child {\n     border-right: 1px solid #ddd;\n   }\n   \n   .login-tab.active {\n     background: #3498db;\n     color: white;\n   }\n   \n   .login-tab:hover:not(.active) {\n     background: #ecf0f1;\n   }\n   \n   /* Loading screen */\n   .loading-screen {\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     min-height: 100vh;\n     background: #f5f5f5;\n   }\n   \n   .loading-spinner {\n     font-size: 18px;\n     color: #7f8c8d;\n   }\n   \n   /* Modal Overlay */\n   .modal-overlay {\n     position: fixed;\n     top: 0;\n     left: 0;\n     right: 0;\n     bottom: 0;\n     background: rgba(0, 0, 0, 0.5);\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     z-index: 1000;\n   }\n   \n   .modal-content {\n     background: white;\n     padding: 30px;\n     border-radius: 8px;\n     max-width: 600px;\n     width: 90%;\n     max-height: 80vh;\n     overflow-y: auto;\n     box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n   }\n   \n   .modal-content h2 {\n     margin-bottom: 20px;\n     color: #2c3e50;\n   }\n   \n   /* Badge colors */\n   .badge-primary {\n     background: #3498db;\n     color: white;\n   }\n   \n   .badge-secondary {\n     background: #95a5a6;\n     color: white;\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
